module.exports = __webpack_public_path__ + "img/广州1978国际人才港.8c475caf.png";